import get from 'lodash.get';
import { connect } from 'react-redux';

import { WIDGET_TYPES } from 'enums/configuration';
import ChatHistory from 'presentation/components/ChatHistory.jsx';
import { getUserEmail, getUserName, getMessages, getHasUserOnboarded } from 'app/modules';
import { getWidgetType } from 'app/modules';
import { isAlternateBucket } from 'lib/handleBucketLogic';
import { isMobileSdk } from 'selectors/app';

export const mapStateToProps = state => {
  let widgetType = getWidgetType(state);
  let isPreIdentifiedUser = !!(getUserEmail(state) && getUserName(state) && !getHasUserOnboarded(state));
  return {
    messageHistory: getMessages(state),
    isChatEnded: !!get(state, 'session.isEnded'),
    isAgentTyping: !!get(state, 'session.isAgentTyping'),
    isDemo: widgetType === WIDGET_TYPES.DEMO_SELF_SERVICE,
    isPreIdentifiedUser,
    isSelfService:
      widgetType === WIDGET_TYPES.SELF_SERVICE ||
      widgetType === WIDGET_TYPES.DEMO_SELF_SERVICE ||
      isAlternateBucket(state.configuration.onboardingTypeTestBucket),
    isMobileSdk: isMobileSdk(state),
  };
};

const ChatHistoryContainer = connect(mapStateToProps)(ChatHistory);

export default ChatHistoryContainer;
